export default {
  OrderInfo: 1,
  Complete: 2,
  Edit: 3,
  Decline: 4,
  Fail: 5,
};
